<template>
  <div class="windows zeromp">
    <div class="mycontainer zeromp">
      <div class="tile parent-contanier zeromp">
        <div class="tile is-ancestor box is-2 zeromp">
          <sidebar :cargo="this.$route.meta.cargo"/>
        </div>

        <div class="tile is-ancestor is-vertical box is-12 zeromp">
          <div class="tile is-parent is-12 zeromp">
            <article class="tile is-child zeromp">
              <div class="content zeromp">
                <internnavbar />
              </div>
            </article>
          </div>

          <div class="tile is-vertical is-12 internbackground">
            <div class="tile is-parent is-vertical">
              <div class="tile is-child">
                <p class="indextitle">Videos</p>

                <div class="tile flex-wrap columns is-mobile respiro">
                  <!--
                  <div class="column is-2" id="tabela-tags">
                    <button
                      class="button field is-danger clean tags"
                      @click="checkedTags = []"
                      :disabled="!checkedTags.length"
                    >
                      <b-icon icon="close"></b-icon>
                      <span>Limpar</span>
                    </button>
                    <b-table
                      class="table-tags"
                      :data="tags"
                      :hoverable="true"
                      :checkable="true"
                      :checked-rows.sync="checkedTags"
                    >
                      <template slot-scope="props">
                        <b-table-column label="Tags">{{ props.row.nome }}</b-table-column>
                      </template>
                    </b-table>
                  </div>
                  -->

                  <tablevideo class="column is-10" :videos="videos" :checkedTags="checkedTags" />
                </div>
              </div>
              <internfooter />
            </div>
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
import internnavbar from "@/components/Navbars/InternNav";
import internfooter from "@/components/Footers/InternFooter";
import sidebar from "@/components/SideBar/SideBar";
import tablevideo from "@/components/Tables/Video";
import MidiaService from "@/services/MidiaService";

export default {
  data() {
    return {
      videos: [],
      tags: [],
      checkedTags: [],
      isEmpty: false
    };
  },
  components: {
    internnavbar: internnavbar,
    internfooter: internfooter,
    sidebar: sidebar,
    tablevideo: tablevideo
  },
  created() {
    /*MidiaService.SearchTags().then(result => {
      result.forEach(tipo => {
        this.tags.push(tipo);
      });
    });*/
    MidiaService.PerfilIndex(
      "video",
      "aluno",
      this.$store.getters.cargo_id
    ).then(result => {
      this.videos = result.data;
    });
  },
  methods: {}
};
</script>
<style scoped>
.table-tags {
  top: 0;
}
.respiro {
  margin-top: 50px;
}
button.clean.tags {
  margin: 0 0 10px 25px;
  width: 70%;
}
</style>